

import React, { useState } from 'react';
import moment from 'moment'

import { Table, Space } from "antd";
import DailySubTable from './DailySubTable';
import axios from 'axios';




export default function MonthlySubTable({ data, negozio, interval }) {

    const [daily, setDaily] = useState([]);
    const [loading, setLoading] = useState(false);

    const [expandedRowKeys, setExpandedRowKeys] = useState([]);


    function onTableRowExpand(expanded, record) {
        var keys = [];
        if (expanded) {
            keys.push(record.id); // I have set my record.id as row key. Check the documentation for more details.
        }
        setExpandedRowKeys(keys)
    }


    function fetchDailyData(start_time, end_time) {
        setLoading(true)
        setDaily(null)
        axios
            .get(
                `${process.env.REACT_APP_SERVER_URL}/api/dati/shops_interval/${negozio}?start=${start_time}&end=${end_time}&interval=day`
            )
            .then((response) => {
                console.log(response)
                // this.setState({ dataSource: response.data.dateFilter.buckets[0].negozi.buckets }, () => { console.log(this.state.dataSource) })
                setDaily(response.data.dateFilter.buckets[0].negozi.buckets[0].per_negozio.buckets)
            })
            .catch((error) => {
                // handle error
                console.log(error);
            })
            .then(() => {
                // always executed
                setLoading(false)
            });
    }


    function dailyData(expanded, record) {

        var keys = [];
        if (expanded) {
            keys.push(record.key); // I have set my record.id as row key. Check the documentation for more details.
        }
        setExpandedRowKeys(keys)

            let start_time = moment(record.key_as_string).format("YYYY-MM-DD")
            let end_time = moment(record.key_as_string).add(1, 'M').format("YYYY-MM-DD")
            fetchDailyData(start_time, end_time)
            console.log(expanded)
            console.log(record)
    }



    const columns = [
        {
            title: 'Mesi',
            dataIndex: 'key_as_string',
            key: 'key_as_string',
            render: (text, row) => (
                <Space size="middle" key={row.key}>
                    { interval === "year" ? <p>{moment(row.key_as_string).format("YYYY")}</p> : <p>{moment(row.key_as_string).format("MMMM YYYY")}</p>}
                </Space>
            ),
        },
        {
            title: 'Num. trans.',
            dataIndex: 'quantita',
            key: 'quantita',
            render: (text, row) => (
                <Space size="middle" key={row.key}>
                    <p>{row.quantita}</p>
                </Space>
            ),
        },
        {
            title: 'Spesa media',
            dataIndex: 'prezzo_medio',
            key: 'prezzo_medio',
            render: (text, row) => (
                <Space size="middle" key={row.key}>
                    {row.prezzo_medio ? <p>{row.prezzo_medio.toFixed(2)}</p> : <p>non calcolato</p>}
                </Space>
            ),
        },
        {
            title: 'Valore',
            dataIndex: 'valore',
            key: 'valore',
            render: (text, row) => (
                <Space size="middle" key={row.key}>
                    <b>{(row.valore).toFixed(2)}</b>
                </Space>
            ),
        },
    ];
    return <Table columns={columns}
        dataSource={data}
        pagination={true}
        expandable={{
            expandedRowKeys: expandedRowKeys,
            expandedRowRender: record => <DailySubTable data={daily} loading={loading} />,
            onExpand: (expanded, record) => dailyData(expanded, record),
            rowExpandable: () => interval === 'month',
            pagination: true
        }} />;
} 
